import { render } from "./MediaOverlayHeader.vue?vue&type=template&id=2958f110&scoped=true"
import script from "./MediaOverlayHeader.vue?vue&type=script&lang=js"
export * from "./MediaOverlayHeader.vue?vue&type=script&lang=js"

import "./MediaOverlayHeader.vue?vue&type=style&index=0&id=2958f110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2958f110"]])

export default __exports__